module.exports = __webpack_public_path__ + "img/chargingpoint-in-progress.17952983.svg";